import React, { useState, useEffect } from "react";
import { LOCALE } from "../../properties/Locale";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { Link, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowSuccessMessage,
  triggerRerender,
} from "../../common/actions/CommonActions";
import {
  TextField,
  Grid,
  Paper,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardMedia,
  Dialog,
  Icon,
  IconButton,
  DialogContent,
  DialogActions,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import EntityMetadata from "../../common/components/EntityMetadata";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { FormBuilderRepository } from "../form-builder/FornBuilderRepository";
import { VacancyRepository } from "./VacancyRepository";
import CardBody from "../../common/components/Card/CardBody";
import Card from "../../common/components/Card/Card";
import CardHeader from "../../common/components/Card/CardHeader";
import { GradingSchemaRepository } from "../configuration/gradingSchema/GradingSchemaRepository";

const useStyles = makeStyles(styles);

export default function VacancyEditComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [vacancyId] = useState(props.match.params.vacancyId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [rerender, triggerRerenderLocal] = React.useState(false);
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [orderDirection, setOrderDirection] = useState("ASC");
  const [gradingSchemas, setGradingSchemas] = useState();
  const [redirectTo, setRedirectTo] = useState();

  const handleChange = (event, name) => {
    let vacData = data;
    if (name === "gradingSchema") {
      data[name].id = event.target.value;
    } else {
      data[name] = event.target.value;
    }
    setData(vacData);
    triggerRerenderLocal(!rerender);
  };
  const handleChangeBoolean = (name, value) => {
    let vacData = data;
    vacData[name] = value;
    setData(vacData);
    triggerRerenderLocal(!rerender);
  };
  const handleSubmit = () => {
    VacancyRepository.save(data).then(
      (res) => {
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(LOCALE.vacancy_update_success_message)
        );

        triggerRerenderLocal(!rerender);
        setRedirectTo("/app/vacancy");
      },
      (err) => {}
    );
  };
  useEffect(() => {
    GradingSchemaRepository.fetchAllGradingSchemas({
      page: 0,
      size: 100,
      orderBy: orderBy,
      orderDirection: orderDirection,
    }).then((res) => {
      setGradingSchemas(res.data.content);
      triggerRerenderLocal(!rerender);
    });

    const loadVacancy = (id) => {
      setLoading(true);
      VacancyRepository.findById(id).then((res) => {
        setData(res.data);
        setLoading(false);
        triggerRerenderLocal(!rerender);
      });
    };

    loadVacancy(vacancyId);
  }, [vacancyId]);

  const handleChangeDate = (date, name) => {
    let tmp = data;
    tmp[name] = date;
    setData(tmp);
    triggerRerenderLocal(!rerender);
  };

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <Dialog
          open={true}
          onClose={() => {}}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.edit_vacancy}${data?.name ? ": " + data?.name : ""}`}
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            <DialogContent>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.name}
                    variant="outlined"
                    margin="dense"
                    value={data?.name}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => handleChange(e, "name")}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.description}
                    multiline={true}
                    rows={3}
                    margin="dense"
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={data?.description}
                    onChange={(e) => handleChange(e, "description")}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              {gradingSchemas && data && (
                <Grid container spacing={3}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <FormControl
                      className={classes.formControl}
                      variant="outlined"
                      size="small"
                      fullWidth
                      margin="dense"
                    >
                      <InputLabel id="demo-simple-select-label1">
                        Шема за оценување
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label1"
                        id="demo-simple-select1"
                        label="Шема за оценување"
                        value={data.gradingSchema.id}
                        onChange={(e) => handleChange(e, "gradingSchema")}
                      >
                        {gradingSchemas.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={5}>
                    <FormControl
                      className={classes.formControl}
                      variant="outlined"
                      size="small"
                      fullWidth
                      margin="dense"
                    >
                      <InputLabel id="demo-simple-select-label">
                        Тип на конкурс
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Тип на конкурс"
                        value={data?.vacancyType}
                        onChange={(e) => handleChange(e, "vacancyType")}
                      >
                        <MenuItem key="TEACHER_MENTOR" value="TEACHER_MENTOR">
                          Наставник-Ментор
                        </MenuItem>
                        <MenuItem key="TEACHER_ADVISOR" value="TEACHER_ADVISOR">
                          Наставник-Советник
                        </MenuItem>
                        <MenuItem
                          key="ASSOCIATE_MENTOR"
                          value="ASSOCIATE_MENTOR"
                        >
                          Стручен Соработник-Ментор
                        </MenuItem>
                        <MenuItem
                          key="ASSOCIATE_ADVISOR"
                          value="ASSOCIATE_ADVISOR"
                        >
                          Стручен Соработник-Советник
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
              )}

              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        format="MM/dd/yyyy"
                        inputVariant="outlined"
                        margin="dense"
                        id="date-from"
                        label={LOCALE.startDate}
                        value={data && data.startDate}
                        onChange={(date) => handleChangeDate(date, "startDate")}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        format="MM/dd/yyyy"
                        inputVariant="outlined"
                        margin="dense"
                        id="date-to"
                        label={LOCALE.endDate}
                        value={data && data.endDate}
                        onChange={(date) => handleChangeDate(date, "endDate")}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.max_points}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.commission}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsCommission")}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.advisor}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsAdvisor}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsAdvisor")}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.school}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsSchool}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsSchool")}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.total}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsTotal}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsTotal")}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>
                      {LOCALE.min_points_for_commision_eval}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.training}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsTraining}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "minPointsTraining")}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.professional_development}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "minPointsCommission")}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.min_points_for_ranklist}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.commission}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistCommission")
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.advisor}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistAdvisor}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistAdvisor")
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.school}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistSchool}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistSchool")
                      }
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.commission_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.commissionEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "commissionEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.commissionEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "commissionEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.bureau_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.bureauEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "bureauEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.bureauEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "bureauEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.eduCenter_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.eduCenterEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "eduCenterEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.eduCenterEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "eduCenterEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.school_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.schoolEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "schoolEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.schoolEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "schoolEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={data && data.isCustom}
                          value={data && data.isCustom}
                          onChange={(e) =>
                            handleChangeBoolean("isCustom", e.target.checked)
                          }
                          name="Дали конкурсот се однесува на одредена листа на училишта?"
                        />
                      }
                      label="Дали конкурсот се однесува на одредена листа на училишта?"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <EntityMetadata data={data} />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <Button size="small" variant="outlined" color="secondary">
                  {LOCALE.close}
                </Button>
              </Link>
              <Button
                type="submit"
                size="small"
                variant="contained"
                color="primary"
                disabled={btnSubmitLoading}
                className={btnSubmitLoading ? "btn-loading" : ""}
                onClick={handleSubmit}
              >
                {LOCALE.save}
                {btnSubmitLoading && (
                  <CircularProgress
                    color="secondary"
                    size={20}
                    style={{ position: "absolute" }}
                  />
                )}
              </Button>
            </DialogActions>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
